import { render, staticRenderFns } from "./FormTabLanguages.vue?vue&type=template&id=2ff8d959&scoped=true&"
import script from "./FormTabLanguages.vue?vue&type=script&lang=js&"
export * from "./FormTabLanguages.vue?vue&type=script&lang=js&"
import style0 from "./FormTabLanguages.vue?vue&type=style&index=0&id=2ff8d959&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff8d959",
  null
  
)

export default component.exports